(() => {
  angular
    .module('app.settings')
    .controller('FreewheelEditModalController', FreewheelEditModal);

  FreewheelEditModal.$inject = [
    '$q',
    'close',
    'provider',
    'integration',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function FreewheelEditModal(
    $q,
    close,
    provider,
    integration,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;
    vm.integration = integration;

    let originCountry = 'DK';
    let originMetrics = [];
    let closeWithReload = false;

    vm.saveEnable = () => vm.isCountryChanged || vm.isMetricsChanged;

    function initIntegration() {
      $(window).scrollTop(0);

      const {
        country,
        qualityMetrics,
      } = vm.integration;

      originCountry = country;
      originMetrics = qualityMetrics || [];

      initCountries();
      initMetrics();

      // vm.isProcessBusy = false;
    };
    initIntegration();



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    function initCountries() {
      vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
      vm.selectedCountry = vm.countries.find(item => item.code === originCountry);
    };

    vm.onSelectCountry = country => {
      vm.selectedCountry = country;
      vm.isCountryChanged = country.code !== originCountry;
    };



    /* ************************************************************* */
    /* *************************** Quality ************************* */
    /* ************************************************************* */
    function initMetrics() {
      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: originMetrics && originMetrics.includes(item.key),
      }));
    }

    const onEditMetrics = () => {
      const selectedMetrics = vm.metrics.filter(item => item.checked).map(item => item.key);
      vm.isMetricsChanged = (originMetrics && !_.isEqual(selectedMetrics.sort(), originMetrics.sort())) ||
        (!originMetrics && selectedMetrics.length !== 0);
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
      onEditMetrics();

    };



    /* ************************************************************* */
    /* *************************** Pixels ************************** */
    /* ************************************************************* */
    vm.pixels = [{
      type: 'impression',
      url: vm.integration.impressionUrl,
    }, {
      type: 'click',
      url: vm.integration.clickUrl,
    }, {
      type: 'videostart',
      url: vm.integration.videoStartUrl,
    }, {
      type: 'video25pct',
      url: vm.integration.firstQuartileUrl,
    }, {
      type: 'video50pct',
      url: vm.integration.midpointUrl,
    }, {
      type: 'video75pct',
      url: vm.integration.thirdQuartileUrl,
    }, {
      type: 'videocomplete',
      url: vm.integration.completeUrl,
    }];



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onSave = () => {
      vm.isProcessBusy = true;

      const { integrationCode } = vm.integration;

      provider.update({
        integrationCode: integrationCode || null,
        country: vm.selectedCountry.code,
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        vm.isProcessBusy = false;
        vm.onFinish();
      });
    };

    vm.onFinish = () => close(true, 0);
    vm.onClose = () => close(closeWithReload, 0);

    const collapsed = {
      integration: false,
      country: true,
      quality: true,
      pixels: true,
    };
    vm.sectionCollapsed = section => collapsed[section];
    vm.onSectionCollapse = section => collapsed[section] = !collapsed[section];

    vm.onClipboardSuccess = () => {
      Notification.showSimpleSuccessMessage(
        'You’ve copied a tracking pixel to the clipboard.',
        'Copied to clipboard', 5);
    };
  }
})();
